<template>
  <div>
    <progressBar />
  </div>
</template>

<script>
import progressBar from './templates/progressBar.vue'
export default {
  name: 'Dashboard',
  components: {
    progressBar
  },
  data () {
    return {}
  },
  created() {
    //this.$store.dispatch('loadApps');
    //this.$store.dispatch('loadAceite');
    /*this.$store.dispatch('loadMarketing');
    this.$store.dispatch('loadAtendimento');
    this.$store.dispatch('loadPagamento');
    this.$store.dispatch('loadLogistica');*/
    //this.$store.dispatch('loadDados');
    /*this.$store.dispatch('loadDominio');
    this.$store.dispatch('loadApps');
    this.$store.dispatch('loadAparencia');
    this.$store.dispatch('loadFaturamento');*/
  }
}
</script>
